







import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['isMobole']),

})
export default class ArrowDown extends Vue {
  isMobole!: Boolean;


  mounted() {

  }


}
